import React from 'react';
import { FieldTypes } from './PortalState/SectionDataMetaData';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import PortalSettingsColorInput from "../../../components/PortalSettingsColorInput";
import ToggleSwitchLabel from './Components/ToggleSwitchLabel';
import SettingSelectField from "../../../components/SettingSelectField";
import SwitchInput from "../../../components/SwitchInput";
import SettingTextField from "../../../components/SettingTextField";
import SettingFileInput from "../../../components/SettingFileInput";

const getInputComponent = ({ sectionName, fieldMetaData, value, errors, styles = {}, handleChange, fileUploadApi }) => {
    const onInputChange = (value) => {
        handleChange(sectionName, fieldMetaData.name, value);
    }

    const onFileInputChange = (file, data) => {
        fileUploadApi(file, data, fieldMetaData.name, sectionName);
    }

    switch (fieldMetaData.type) {
        case FieldTypes.color:
            return (<PortalSettingsColorInput
                label={fieldMetaData.label}
                field={fieldMetaData.name}
                value={value}
                info={fieldMetaData.info}
                error={errors.get(fieldMetaData.name)}
                handleInputChange={onInputChange}
            />);
        case FieldTypes.switch:
            return (<Box>
                <ToggleSwitchLabel
                    label={fieldMetaData.label}
                    info={fieldMetaData.info}
                    styles={styles}
                />
                <Box mt={2}>
                    <SwitchInput
                        checked={(value === null || value === undefined) ? fieldMetaData.defaultValue : value}
                        onChange={onInputChange}
                    />
                </Box>
            </Box>);
        case FieldTypes.stringInput:
            return (<>
                <Box mb={1}>
                    <Typography className={styles.textInputLabel} sx={{
                        color: "#000000",
                        fontSize: 14.5,
                        fontFamily: "GilroySemiBold !important",
                    }}>
                        {fieldMetaData.label}
                    </Typography>
                </Box>
                <SettingTextField
                    page={"customRestaurantInfo"}
                    editable={true}
                    value={value?.displayName}
                    setValue={onInputChange}
                    placeholder={""}
                    required={true}
                    variant={"filled"}
                    border={"1px solid #AAA"}
                    error={errors.get(fieldMetaData.name)}
                />
            </>);
        case FieldTypes.fontsize:
            return (<>
                <Box mb={1}>
                    <Typography className={styles.textInputLabel} sx={{
                        color: "#000000",
                        fontSize: 14.5,
                        fontFamily: "GilroySemiBold !important",
                    }}>
                        {fieldMetaData.label}
                    </Typography>
                </Box>
                <SettingTextField
                    page={"customRestaurantInfo"}
                    editable={true}
                    value={value}
                    setValue={(value) => onInputChange(value.replace(/[^0-9.]/g, ""))}
                    placeholder={""}
                    required={true}
                    variant={"filled"}
                    border={"1px solid #AAA"}
                    error={errors.get(fieldMetaData.name)}
                />
            </>);
        case FieldTypes.select:
            return (<SettingSelectField
                editable={true}
                page={"customRestaurantInfo"}
                value={value ?? fieldMetaData.defaultValue}
                setValue={onInputChange}
                label={fieldMetaData.label}
                placeholder={""}
                required={true}
                variant={"filled"}
                border={"1px solid #AAA"}
                menuList={fieldMetaData.optionsList}
                error={errors.get(fieldMetaData.name)}
            />)
        case FieldTypes.file:
            return <Grid item xs={12}>
                <Box mb={1}>
                    <Typography className={styles.textInputLabel} sx={{
                        color: "#000000",
                        fontSize: 14.5,
                        fontFamily: "GilroySemiBold !important",
                    }}>
                        {fieldMetaData.label}
                    </Typography>
                </Box>
                <Box>
                    <SettingFileInput
                        id={fieldMetaData.name}
                        type={fieldMetaData.name}
                        value={value?.displayName ?? null}
                        setValue={() => null}
                        uploadFile={onFileInputChange}
                        border={"1px solid #AAA"}
                        error={errors.get(fieldMetaData.name)}
                        onRemove={() => { onInputChange(null) }}
                    />
                </Box>
            </Grid>
        default: return null;
    }
}

const TabPanelTemplate = ({ sectionName, SectionMetaData, data, styles, errors, handleChange, fileUploadApi }) => {
    return (<Grid container spacing={2}>
        {Object.entries(SectionMetaData).map(([field, fieldMetaData]) => {
            return (<Grid item xs={12} md={3} mt={2} key={field}>
                {getInputComponent({ sectionName, fieldMetaData: fieldMetaData, value: data[fieldMetaData.name], errors, styles, handleChange, fileUploadApi })}
            </Grid>)
        }
        )}
    </Grid>);
}

export const ARTabPanel = ({ sectionName, SectionMetaData, data, styles, errors, handleChange, fileUploadApi }) => {
    const ARSectionMetaData = { ...SectionMetaData.normalRender };
    // If the arCategoryGrouping toggle switch is on, add the dropdown field to the normal rendering, otherwise don't.
    if (data.arCategoryGrouping) {
        ARSectionMetaData.arCategoryGroupingPosition = SectionMetaData.conditionalRender.arCategoryGroupingPosition;
    }

    return <TabPanelTemplate
        sectionName={sectionName}
        SectionMetaData={ARSectionMetaData}
        data={data}
        styles={styles}
        errors={errors}
        handleChange={handleChange}
        fileUploadApi={fileUploadApi}
    />
}

export default TabPanelTemplate;